import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'

const UniversalChoiceModal = ({
  label = 'Название',
  placeholder = 'Введите название',
}) => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  return (
    <FormField>
      <FormLabel isRequired>{label}:</FormLabel>
      <FormInput isError={check('value')}>
        <input
          name='value'
          type='text'
          onChange={(e) => changeValues(e.target.value, 'value')}
          placeholder={placeholder}
          value={modalValue?.value || ''}
          autoFocus
        />
      </FormInput>
    </FormField>
  )
}

export default observer(UniversalChoiceModal)
